import theme from "../components/style/Theme"

export default theme
